import { StyleSheet, Platform } from 'react-native'
import { whiteBackgroundColor, corporateColor, white } from '../../theme/colors'
import { DOBRA, DOBRA_LIGTH } from '../../theme/fonts'

export const styles = StyleSheet.create({
  text: {
    fontSize: 16,
    color: white,
    marginBottom: 24,
    marginTop: 24,
    textAlign: 'center',
    fontWeight: '400',
    fontFamily: DOBRA,
  },
  cardContainer: {
    backgroundColor: whiteBackgroundColor,
    borderRadius: 10,
    paddingTop: 30,
    padding: 30,
    marginBottom: 20,
  },

  title: {
    color: corporateColor,
    fontSize: 20,
    textAlign: 'left',
    fontWeight: '500',
    fontFamily: DOBRA,
  },

  subTitle: {
    color: corporateColor,
    fontSize: 20,
    fontFamily: DOBRA_LIGTH,
    textAlign: 'right',
    ...(Platform.OS === 'android' ? {} : { paddingBottom: 10 }),
  },

  welcome: {
    fontFamily: DOBRA,
    fontSize: 24,
    fontWeight: '300',
    color: white,
    textAlign: 'center',
    marginBottom: 24,
    marginTop: 40,
  },
})
